import { useWealthSavingsSectionContent } from './useWealthSavingsSectionContent';
import { parseWealthSavingsHeroContent } from '../utils/wealthSavingsContent';

export const useWealthSavingsHeroContent = () =>
  useWealthSavingsSectionContent(parseWealthSavingsHeroContent);
